import React from "react"
import { Formik, Form as FormWrap } from "formik"

const Form = ({ fields }) => {
  return (
    <Formik>
      {formik => (
        <div>
          <FormWrap></FormWrap>
        </div>
      )}
    </Formik>
  )
}

export { Form }
